import React from 'react'

export default function useRectangleDrawing(
  map: google.maps.Map | null,
  isActive: boolean,
  options: google.maps.RectangleOptions,
  onComplete: (rect: google.maps.Rectangle) => void
) {
  React.useEffect(() => {
    if (!map || !isActive) return

    map.setOptions({ draggable: false, cursor: 'crosshair' })

    let startLatLng: google.maps.LatLng | null = null
    let rect: google.maps.Rectangle | null = null

    const onMouseDown = (e: google.maps.MapMouseEvent) => {
      if (!e.latLng) return
      startLatLng = e.latLng
      rect = new google.maps.Rectangle({
        map,
        bounds: new google.maps.LatLngBounds(e.latLng, e.latLng),
        ...options,
      })
    }

    const onMouseMove = (e: google.maps.MapMouseEvent) => {
      if (!startLatLng || !rect || !e.latLng) return
      rect.setBounds(new google.maps.LatLngBounds(startLatLng, e.latLng))
    }

    const onMouseUp = (e: google.maps.MapMouseEvent) => {
      if (!startLatLng || !rect || !e.latLng) return
      rect.setBounds(new google.maps.LatLngBounds(startLatLng, e.latLng))
      const completed = rect
      completed.setMap(null)
      rect = null
      startLatLng = null
      onComplete(completed)
    }

    const listeners = [
      map.addListener('mousedown', onMouseDown),
      map.addListener('mousemove', onMouseMove),
      map.addListener('mouseup', onMouseUp),
    ]

    return () => {
      listeners.forEach(l => google.maps.event.removeListener(l))
      map.setOptions({ draggable: true, cursor: '' })
      if (rect) {
        rect.setMap(null)
        rect = null
      }
    }
  }, [map, isActive]) // eslint-disable-line
}
